export function matchSnapshot(catalogItem, snapshots, index, { isHome = false } = {}) {
  if (!Array.isArray(snapshots) || snapshots.length === 0) return null

  if (!isHome && catalogItem?.uid) {
    const byUid = snapshots.find((row) => row?.uid && row.uid === catalogItem.uid)
    if (byUid) return byUid
  }

  const catalogCode = isHome
    ? catalogItem?.scode || catalogItem?.sCode
    : catalogItem?.sCode || catalogItem?.scode
  if (catalogCode) {
    const byCode = snapshots.find((row) => (row?.sCode || row?.scode) === catalogCode)
    if (byCode) return byCode
  }

  return snapshots[index] || null
}

export function zaraSizeName(item, group) {
  const isCocuk = group?.name?.includes('ÇOCUK')
  const isBebek = group?.name?.includes('BEBEK')
  if (isCocuk || isBebek) {
    return item?.size ? String(item.size).split(' ')[0] : String(item?.europe ?? '')
  }
  return item?.europe != null ? String(item.europe) : ''
}

export function homeDynamicFields(item) {
  if (!item || typeof item !== 'object') return {}
  return Object.keys(item).reduce((acc, key) => {
    if (['scode', 'amount', 'amountWithDefect', 'name'].includes(key)) return acc
    if (typeof item[key] !== 'string') return acc
    acc[key] = item[key] || ''
    return acc
  }, {})
}

export function keepCustomInchRows(mapped, snapshots) {
  if (!Array.isArray(snapshots)) return mapped
  const extras = snapshots.filter((row) => row?.isCustomInch)
  if (extras.length === 0) return mapped
  return [...mapped, ...extras]
}
